import {ChevronIcon} from '~library/svg/ChevronIcon';
import './UpDownChevron.sass';

export const UpDownChevron = ({up, ratio = 1}) =>
  up ? (
    <ChevronIcon ratio={ratio} className="up_down_chrevroon--up" />
  ) : (
    <ChevronIcon ratio={ratio} className="up_down_chrevroon--down" />
  );
